<div class="mention-editor-wrap">
  <div #editor class="mention-editor form-control" contenteditable="true" role="textbox" aria-multiline="true"
       [attr.aria-label]="placeholder" [attr.data-placeholder]="placeholder"
       [style.height.em]="minRows * 1.5 + 1" (input)="onInput()" (keydown)="onKeydown($event)" (blur)="onBlur()"
       (paste)="onPaste($event)" (drop)="onDrop($event)" (click)="onEditorClick($event)"
       (scroll)="positionSuggestions()"></div>
  <div *ngIf="suggestions.length" class="mention-suggestions" role="listbox" aria-label="Mention suggestions"
       [style.top.px]="suggestionTop" [style.left.px]="suggestionLeft">
    <button *ngFor="let user of suggestions; let i = index" type="button" role="option"
            class="mention-suggestion" [class.active]="i === activeSuggestion"
            [attr.aria-selected]="i === activeSuggestion"
            (pointerdown)="$event.preventDefault(); selectSuggestion(user)">{{ user.fullname }}</button>
  </div>
</div>
